// extracted by mini-css-extract-plugin
export default {"container":"Ko-z","bubbleNav":"Lo-z","graphic":"Mo-z","contact":"No-z"};